
// Import css files
import { Link } from "react-router-dom";
import bulb from '../../../../../assets/images/bulbbanking.png';
import expiryclock from '../../../../../assets/images/expiryclock.svg';
import blogheadicon from '../../../../../assets/images/blogheadicon.svg';
import bankingicon from '../../../../../assets/askTheExpertImages/bankingmenuicon.svg';
import sand from '../../../../../assets/images/sandarticle.png';
import React from 'react';

import { convertToCanadianDateTime, decodeHtmlEntities } from "../../../../../shared/helper";

const BankingArticleDetailsV2Jsx = (props) => {
  const {
    detailsData
  } = props;
  
  return (
    <>

<section className="bankinversiononedetailblog">
        <div className="container">
          <div className="blogsectioone">
            <div className="row">
              <div className="col-lg-7 col-sm-7">
                <div className="blogsectiooneleft">
                  <div className="tagreal"><span><img src={bankingicon} alt="Banking Icon" /></span>{detailsData?.['_embedded']?.['wp:term']?.[0]?.[0]?.name}</div>
                  <div className="blogsectioleft">
                    <div className="title">
                      <h1>{decodeHtmlEntities(detailsData?.title?.rendered)}</h1></div>
                      <div dangerouslySetInnerHTML={{ __html: detailsData?.acf?.variant_2?.banner_sectionn.short_description }}></div>
                    
                  </div></div>
                <div className="anptag"><p>{detailsData?.acf?.variant_2?.banner_sectionn.description}</p></div>

              </div>
              <div className="col-lg-5 col-sm-5">
                <div className="blogsectioright">
                  <img src={detailsData?.acf?.variant_2?.banner_sectionn?.image} alt="bannermage" />
                  <div className="d-flex userdetails">
                    <div className="userphoto">
                      <img src={`https://ui-avatars.com/api/?name=${detailsData?.['_embedded']?.['author']?.[0]?.name}&rounded=true`} alt={`${detailsData?.['_embedded']?.['author']?.[0]?.name}`} />
                    </div>
                    <div className="username">{detailsData?.['_embedded']?.['author']?.[0]?.name}</div>
                  </div>
                </div>
                <p className="articlepublishdate mt-2"><span><img src={expiryclock} alt="clock" /></span>{convertToCanadianDateTime(detailsData?.date)}</p>
              </div>
            </div>

          </div>
          <div className="blogsectiotwo">
            <div className="blogsectiotwoinner">
              <h2>{detailsData?.acf?.variant_2?.overview_section.title}</h2>
              <p>
              {detailsData?.acf?.variant_2?.overview_section.description}
              </p>
              {detailsData?.acf?.variant_2?.overview_section.tagline}
            </div>
          </div>
          <div className="blogsectiothree">
            <div className="row">
              <div className="col-lg-7 col-sm-7">
                <div className="blogsectiothreeleft">
                  <h2><span><img src={sand} alt="bankingicon" /></span>{detailsData?.acf?.variant_2?.overview_section_2.title}</h2>
                  <p>{detailsData?.acf?.variant_2?.overview_section_2.description}</p>

                </div>
              </div>
              <div className="col-lg-5 col-sm-5">
                <div className="blogsectiothreeright">
                  <h2>{detailsData?.acf?.variant_2?.overview_section_2.title_2}</h2>
                  <ul>
                  {detailsData?.acf?.variant_2?.overview_section_2.criteria.map((item,index) => (                  
                    <li>
                      <span>{String.fromCharCode(65 + index)}</span>
                      <p>{item?.item} </p>
                    </li>
                  ))}
                   
                  </ul>
                </div>
              </div>
            </div>
            <div className="blogsectiothreeimage"><img src={detailsData?.acf?.variant_2?.overview_section_2.image} alt="blogimage" /></div>
          </div>
          <div className="blogsectiofour">
            <h2>{detailsData?.acf?.variant_2?.benefits_section.title}  </h2>
            <p>{detailsData?.acf?.variant_2?.benefits_section.short_description} </p>
            <div className="row">
            {detailsData?.acf?.variant_2?.benefits_section.benefits.map((item,index)=>(
              <div className="col">
                <div className="blogsectiofourinner">
                  <div className="serialnumber">{ String(index+1).padStart(2, '0')}</div>
                  <h4>{item?.title}</h4>
                  <p>{item?.description}</p>
                </div>
              </div>
              ))}
              
              
              

            </div>

          </div>
          <div className="blogsectiofive">
            <div className="row">

              <div className="col-lg-9 col-sm-9">
                <div className="blogsectiofivemiddle">
                  <div className="blogsectiofivemiddleinner">
                    <ul>
                    {detailsData?.acf?.variant_2?.offer_section.step.map((item,index)=>(
                      <li>
                        <img src={blogheadicon} alt="blogimage" />
                        <h3>Step {index}</h3>
                        <h4>{item?.heading}</h4>
                        <p>{item?.description}</p>
                      </li>
                      ))}

                     
                    </ul>

                  </div>

                </div>
              </div>
              <div className="col-lg-3 col-sm-3">
                <div className="blogsectiofiveright">
                  <div className="bulb">
                    <img src={bulb} alt="bulb" />
                  </div>
                  <h2>{detailsData?.acf?.variant_2?.conclusion_section.title}</h2>
                  <div dangerouslySetInnerHTML={{ __html: detailsData?.acf?.variant_2?.conclusion_section.description }}></div>                  
                  <Link to={detailsData?.acf?.variant_2?.conclusion_section.apply_url} className="applynow">Apply Now</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      

    </>

  );
};

export default BankingArticleDetailsV2Jsx;